<template>
  <div>
    <div
      class="d-flex align-item-center justify-content-between overflow-hidden"
      :class="{
        'justify-content-center': $store.getters['enums/operator'] === 'eJ',
      }"
      style="height: 100vh"
    >
      <div
        class="d-flex justify-content-center align-items-center mx-auto p-3"
      >
        <div>
          <div class="title mb-2">
            <img
              src="@/assets/images/fanoos-ramadan.png"
              alt="fanoos-ramadan"
              class="fanoos-ramadan"
              v-if="isRamadan"
            />
            <img
              v-if="$store.getters['enums/operator'] === 'eJ'"
              src="@/assets/logo/SSS/SAPTCO-Logo-01.png"
              alt="login-title-vector"
              width="350px"
            />
          </div>
          <div class="form">
            <router-view v-slot="slotProps">
              <transition name="route" mode="out-in">
                <component :is="slotProps.Component"></component>
              </transition>
            </router-view>
          </div>
          <div class="bottom-container" v-if="false">
            <span> {{ $t("do-not-have-an-account-yet") }} </span>
            <span class="link"> {{ $t("sign-up-with-rekab") }} </span>
          </div>
        </div>
      </div>
      <div class="image-container d-none d-md-block">
        <img :src="loginImage" alt="login" class="login-image" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Auth",
  data() {
    return {
      isSaudiFoundingDay: false,
      isRamadan: false,
      isEid: false,
      isEidAdha: false,
    };
  },
  computed: {
    loginImage() {
      if (this.isRamadan) {
        return require('@/assets/images/ramadan-theme.jpg');
      } 
      if (this.isSaudiFoundingDay) {
        return require('@/assets/images/saudi-founding-day.jpg');
      } 
      if (this.isEid) {
        return require('@/assets/images/eid-theme.png');
      } 
       if (this.isEidAdha) {
        return require('@/assets/images/eid-adha-theme.jpg');
      }
      return require('@/assets/images/NOC_account.jpg');
    }
  },
  i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/auth.json"),
      ar: require("@/services/i18n/locales/ar/auth.json"),
    },
  },
};
</script>

<style lang="scss">
.form-container {
  padding: 2rem;
  position: relative;
  .link {
    font-weight: 700;
    font-size: 12px;
    color: var(--color-23);
    cursor: pointer;
  }

  .bottom-container {
    position: absolute;
    bottom: 50px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    color: var(--color-02);
  }
}

.image-container {
  position: relative;
  .login-vector {
    position: absolute;
    top: 30px;
    left: 30px;
  }
  .login-image {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
}
.fanoos-ramadan {
  width: 40px;
  position: absolute;
  inset-block-start: -10px;
  inset-inline-start: 34px;
  animation: swing 25s ease-in-out infinite;
  transform-origin: 50% 0%;
}
@keyframes swing {
  0%, 80%, 100% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(20deg);
  }
  20% {
    transform: rotate(-15deg);
  }
  30% {
    transform: rotate(10deg);
  }
  40% {
    transform: rotate(-5deg);
  }
  50% {
    transform: rotate(3deg);
  }
  60% {
    transform: rotate(-2deg);
  }
  70%, 90% {
    transform: rotate(1deg);
  }
}

@media (min-width: 992px) {
  .app {
    .form-container {
      margin-inline-start: 6rem !important;
    }
  }
}
</style>
